<script lang="ts" setup>
import type { PropType} from 'vue';
import { onMounted, ref } from 'vue';
import type { ICellRendererParams } from 'ag-grid-community';
import type { BadgeProps } from '@/components/common/Badge.vue';
import Badge from '@/components/common/Badge.vue';

type AgTitleWithBadgeParams = ICellRendererParams & {
    title: ((params: ICellRendererParams) => string) | string;
    subTitle: ((params: ICellRendererParams) => string) | string;
    badgeProps: ((params: ICellRendererParams) => BadgeProps) | BadgeProps;
    readonly: (params: ICellRendererParams) => boolean;
};

const props = defineProps({
    params: {
        type: Object as PropType<AgTitleWithBadgeParams>,
        required: true
    }
});

const title = ref<string>('status');
const subTitle = ref<string>('check');
const badgeParams = ref<BadgeProps>();
const readonly = ref<boolean>(false);

onMounted(() => {
    title.value = typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title;
    subTitle.value = typeof props.params.subTitle === 'function' ? props.params.subTitle(props.params) : props.params.subTitle;
    badgeParams.value = typeof props.params.badgeProps === 'function' ? props.params.badgeProps(props.params) : props.params.badgeProps;
    readonly.value = typeof props.params.readonly === 'function' ? props.params.readonly(props.params) : props.params.readonly;
});
</script>

<template>
    <div :class="['sy-title-field grid-x grid-margin-x', { 'sy-default': readonly }]">
        <div v-tooltip="`<b>${title}</b><br/>${subTitle}`" class="cell auto align-self-middle">
            <span :title="title" class="sy-title-field__title sy-truncate">{{ title }}</span>
            <span :title="subTitle" class="sy-title-field__sub-title sy-truncate">{{ subTitle }}</span>
        </div>
        <div class="cell shrink flex-container align-middle">
            <Badge v-bind="badgeParams" />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.ag-cell {
    line-height: var(--sy-line-height);
}
.sy-title-field {
    height: 100%;

    &__title {
        display: block;
        font-size: var(--sy-font-size-standard);
        line-height: var(--sy-line-height);
        margin-bottom: var(--sy-spacer-2);
    }

    &__sub-title {
        display: block;
        font-size: var(--sy-font-size-small);
        line-height: var(--sy-line-height-sm);
    }
}
</style>
